import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from 'redux-thunk';
import { uiReducer } from '../reducers/uiReducer';
import { falHerramientasReducer } from '../reducers/falHerramientasReducer';

const reducers = combineReducers({
    ui: uiReducer,
    fallherramientas: falHerramientasReducer,
});

/// The Redux DevTools bridge is only wired up in development, so production
/// ships neither the extra dependency nor a hook into the store.
const composeEnhancers = (
    process.env.NODE_ENV === 'development' &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) || compose;

export const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(thunk)
    )
);
